import React from "react";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { classExpression } from "@babel/types";
import { makeStyles } from "@material-ui/styles";
import { generalFormStyles } from './StyleObjects/generalStyles';
import { colors } from '../helpers/styles/colors'
import { ReactIcon } from '../icons/ReactIcon';
import { TypescriptIcon } from '../icons/TypescriptIcon';
import { JavaScriptIcon } from '../icons/JavaScriptIcon';
import { LinkedInIcon } from '../icons/LinkedInIcon';
import { EmailIcon } from '../icons/EmailIcon';
import { GitHubIcon } from '../icons/GitHubIcon';

import { IconLink } from '../components/IconLink';

const useFormStyles = makeStyles(generalFormStyles);

export function Footer() {
    const classes = useFormStyles();
    return (
        <div className={` ${classes.footer}`}>
            <h1 className={classes.footer}>
                Contact
            </h1>
            <IconLink
                rel='noopener noreferrer'
                target='_blank'
                href='https://www.linkedin.com/in/namrata-ajmeri/'
                aria-label='Namrata Linked In page'
                className={`${classes.shareIcon} ${classes.footer}`}
                type='link'
            >
                <LinkedInIcon />
            </IconLink>
            <IconLink
                rel='noopener noreferrer'
                target='_blank'
                href='namrataajmeri1695@gmail.com'
                aria-label='Namrata email'
                className={`${classes.shareIcon} ${classes.footer}`}
                type='link'
            >
                <EmailIcon />
            </IconLink>
            <IconLink
                rel='noopener noreferrer'
                target='_blank'
                href='https://github.com/namrata1695'
                aria-label='Namrata email'
                className={`${classes.shareIcon} ${classes.footer}`}
                type='link'
            >
                <GitHubIcon />
            </IconLink>
        </div>
    );
}